module.exports = __webpack_public_path__ + "static/media/truck.602a6d68.png";